
import { useTranslation } from 'react-i18next';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
/* import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg"; */


export const Skills = () => {
  const [t] = useTranslation("global");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
/*     <img align="center"  height="30" width="40" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg">
    <img align="center"  height="30" width="40" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-plain.svg">
    <img align="center"  height="30" width="40" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg">
    <img align="center"  height="30" width="40" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg">
    <img align="center"  height="30" width="40" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg">
    <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" />
    <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" />
    <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg" />
       <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-plain.svg" />
    <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" />
    <img align="center"  height="30" width="40" fill="white" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" />
    <img align="center"  height="30" width="40" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain-wordmark.svg" /> */
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p><br></br> {t("skills")}</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={'https://ui-lib.com/blog/wp-content/uploads/2021/12/nextjs-boilerplate-logo.png'} alt="nextjs-original" />
                                <h5>Next</h5>
                            </div>
                            <div className="item">
                                <img src={'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg'} alt="react-original" />
                                <h5>React</h5>
                            </div>
                            <div className="item">
                                <img src={'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg'} alt="typescript-plain" />
                                <h5>Typescript</h5>
                            </div>
                            <div className="item">
                                <img src={'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg'} alt="javascript-plain" />
                                <h5>Javascript</h5>
                            </div>
                            <div className="item">
                                <img src={'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg'} alt="angularjs-original" />
                                <h5>Angular</h5>
                            </div>
                            <div className="item">
                                <img src={'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg'} alt="vuejs-original" />
                                <h5>Vue</h5>
                            </div>
                            <div className="item">
                                <img src={'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg'} alt="php-plain" />
                                <h5>PHP</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
